// extracted by mini-css-extract-plugin
export var container = "_6j-0";
export var fallback = "_6j-5";
export var fallbackIcon = "_6j-6";
export var hidden = "_6j-2";
export var image = "_6j-3";
export var loaded = "_6j-4";
export var placeholder = "_6j-1";